import { kuiperClassNames } from '@opallabs/kuiper'
import { Tooltip, Button, ButtonIconPosition } from '@opallabs/lapidary'
import { ReactionUsers } from './ReactionUsers'
import * as styles from './styles'

interface Props {
  displayName: string
  emoji: string
  onClickReaction: (
    reactionId: number,
    reactionTypeId: number,
    removable: boolean
  ) => void
  reactionId: number
  reactionTypeId: number
  removable: boolean
  usernames: string[]
}

export const Reaction: React.FC<Props> = ({
  displayName,
  emoji,
  onClickReaction,
  reactionId,
  reactionTypeId,
  removable,
  usernames,
}) => (
  <li
    css={styles.listItem}
    className={kuiperClassNames(removable ? 'removable' : '')}
  >
    <Tooltip
      content={
        <ReactionUsers
          emoji={emoji}
          displayName={displayName}
          usernames={usernames}
        />
      }
      showArrow={true}
      zIndex={9999}
    >
      <Button
        name={`${displayName} Reactions`}
        buttonText={`${usernames.length}`}
        icon={<span>{emoji}</span>}
        iconPosition={ButtonIconPosition.leading}
        onClick={() => onClickReaction(reactionId, reactionTypeId, removable)}
        variant={removable ? 'secondary' : 'tertiary'}
        styleOverrides={{ button: styles.emojiButtonOverrides }}
      />
    </Tooltip>
  </li>
)
